import React from 'react'

import './action-header-layout.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    header?: React.ReactNode
    filterBar?: React.ReactNode
    children: React.ReactNode
    respectPageTabs?: boolean
  }
>

const ActionHeaderLayout = ({
  className,
  header,
  filterBar,
  children,
  respectPageTabs = false,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn('ActionHeaderLayout', {withHeader: !!header, respectPageTabs}, className)}
  >
    <div className="ActionHeaderLayout__header">
      {filterBar && <div className="ActionHeaderLayout__filterBar">{filterBar}</div>}
      {header}
    </div>
    <div className="ActionHeaderLayout__content">{children}</div>
  </div>
)

export default ActionHeaderLayout
